import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';

const ModalSinStock = (item) => {
    const VISIBLE = item.dadComponent.state.addStock;
    const CARRITO_MODAL = item.dadComponent['showCarrito'];

    return (
        <div>
            <Modal isOpen={VISIBLE} toggle={CARRITO_MODAL} className='modal_notificacion' centered backdrop="static">
                <button className="btn-icon modal-close" onClick={CARRITO_MODAL}><SvgAssets icon="icon-close" fill={c.azulClaro} /></button>
                <h6><SvgAssets icon="icon-warning" fill={c.rojoClaro} /></h6>
                <p className="paragraph-2 light" style={{ color: c.rojoClaro }}>Alguno de tus productos<br /><strong> ya no cuenta con stock y/o precio</strong></p>
                <button className='btn-block' style={{ backgroundColor: c.azulClaro }} type="button" onClick={CARRITO_MODAL}>
                    ENTENDIDO
                </button>
            </Modal>
        </div>
    )
}

export default ModalSinStock;